import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URI } from "../Common/data";
import { Link } from "react-router-dom";
import "./keywordsection.css";

function KeywordFooterSection() {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    fetchKeywordPages();
  }, []);

  const fetchKeywordPages = async () => {
    try {
      const res = await axios.get(`${API_URI}/keyword-landing`);
      if (res.data?.data) {
        const activePages = res.data.data.filter((item) => item.isActive);
        setPages(activePages);
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (pages.length === 0) return null;

  return (
    <section className="keyword-section">
      <div className="keyword-wrapper">
        <h2 className="keyword-heading">Quick Links</h2>

        <div className="keyword-grid">
          {pages.map((item) => (
            <Link
              key={item._id}
              to={`/${item.slug}`}
              className="keyword-card"
              onClick={() =>
                window.scrollTo({ top: 0, behavior: "smooth" })
              }
            >
              {item.heading}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default KeywordFooterSection;
